import { useState } from 'preact/hooks';
import { api, ApiError, errorMessage } from '../lib/api';
import { useSession } from '../session';
import { ErrorBox, Notice } from './ui';

/** "Resend link" for the email-confirmation message (POST /v1/auth/verify/send). */
export function ResendVerification({ asButton = false }: { asButton?: boolean }) {
  const { me, refresh } = useSession();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ ok: boolean; text: string } | null>(null);
  const send = async () => {
    setBusy(true); setMsg(null);
    try {
      const r = await api<{ ok: boolean; alreadyVerified?: boolean }>('/v1/auth/verify/send', { method: 'POST' });
      if (r.alreadyVerified) { setMsg({ ok: true, text: 'Your email is already confirmed.' }); refresh(); }
      else setMsg({ ok: true, text: `Sent — check ${me?.user.email ?? 'your inbox'}.` });
    } catch (e) { setMsg({ ok: false, text: errorMessage(e) }); }
    finally { setBusy(false); }
  };
  return (
    <span class="resend">
      <button type="button" class={asButton ? 'btn sm' : 'link-btn'} onClick={send} disabled={busy} data-testid="resend-verification">{busy ? 'Sending…' : 'Resend link'}</button>
      {msg && <span class={`caption ${msg.ok ? 'ok' : 'bad'}`} role={msg.ok ? 'status' : 'alert'}>{msg.text}</span>}
    </span>
  );
}

/** Checkout/billing error: an unconfirmed email gets its message plus a resend action instead of a generic error. */
export function CheckoutError({ error }: { error: unknown }) {
  if (error instanceof ApiError && error.code === 'email_unverified') {
    return (
      <div data-testid="email-unverified-checkout">
        <Notice tone="warning"><p>{error.message}</p><ResendVerification asButton /></Notice>
      </div>
    );
  }
  return <ErrorBox message={errorMessage(error)} />;
}
